import "./App.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import LandingPage from "./pages/LandingPage";
import Signup from "./pages/Signup";
import Signin from "./pages/Signin";
import Dashboard from "./pages/Dashboard";
import Bankruptcy from "./pages/Bankruptcy";
import Bonus from "./pages/Bonus";
import ChexSystem from "./pages/ChexSystem";
import CreditRepairExpectations from "./pages/CreditRepairExpectations";
import DebtValidation from "./pages/DebtValidation";
import PayForDeletion from "./pages/PayForDeletion";
import ReverseLatePayment from "./pages/ReverseLatePayment";
import TwoWeeksMethod from "./pages/TwoWeeksMethod";
import Cashout from "./pages/Cashout";
import Extra from "./pages/Extra";
import Zoning from "./pages/Zoning";
import UnionList from "./pages/UnionList";
import Secrets from "./pages/Secrets";
import LendingList from "./pages/LendingList";
import Turo from "./pages/Turo";
import Tarik from "./pages/Tarik";
import AdminPanel from "./pages/Admin";
import InquiryRemoval from "./pages/InquiryRemoval";
import DeleteBankruptcy from "./pages/DeleteBankruptcy";
import PurchaseLand from "./pages/PurchaseLand";
import CollectionRemoval from "./pages/CollectionRemoval";
import AirBnb from "./pages/AirBnb";
import ChexRemoval from "./pages/ChexRemoval";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/bankruptcyremoval" element={<Bankruptcy />} />
          <Route path="/bonus" element={<Bonus />} />
          <Route path="/chexsystem" element={<ChexSystem />} />
          <Route path="/debtvalidation" element={<DebtValidation />} />
          <Route
            path="/creditrepairexpectations"
            element={<CreditRepairExpectations />}
          />
          <Route path="/payfordeletion" element={<PayForDeletion />} />
          <Route path="/reverselatepayment" element={<ReverseLatePayment />} />
          <Route path="/twoweeksmethod" element={<TwoWeeksMethod />} />
          <Route path="/cashout/:amount" element={<Cashout />} />
          <Route path="/extra" element={<Extra />} />
          <Route path="/zoning" element={<Zoning />} />
          <Route path="/tarik" element={<Tarik />} />
          <Route path="/secrets" element={<Secrets />} />
          <Route path="/lendinglist" element={<LendingList />} />
          <Route path="/turo" element={<Turo />} />
          <Route path="/deletecollection" element={<CollectionRemoval />} />
          <Route path="/deletebankruptcy" element={<DeleteBankruptcy />} />
          <Route path="/inquiryremoval" element={<InquiryRemoval />} />
          <Route path="/removechex" element={<ChexRemoval />} />
          <Route path="/purchaseland" element={<PurchaseLand />} />
          <Route path="/airbnb" element={<AirBnb />} />
          <Route path="/unionlist" element={<UnionList />} />
          <Route path="/unknown/try/get" element={<AdminPanel />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
